export const isLgbtqiaContant = [
  { displayName: "Yes", id: "yes", value: "yes" },
  { displayName: "No", id: "no", value: "no" },
];

export const isDisabilitiesContant = [
  { displayName: "Yes", id: "yes", value: "yes" },
  { displayName: "No", id: "no", value: "no" },
];

export const participateCheckContant = [
  {
    id: "participateCheck",
    displayName: "I agree to participate in Triumph event",
    value: "1",
  },
];

export const returningToWorkContant = [
  {
    id: "returningToWork",
    displayName: "Returning to work",
    value: "1",
  },
];
